import { Box, Typography } from "@mui/material";
import styles from "./services.module.scss";
import { useState } from "react";
import EducationalActivities from "./educationalActivities";
import SpritualActivities from "./spritualActivities";
import HealthAndWellness from "./healthAndWealth";
import InHouseSupport from "./inHouseSupport";
import FuneralServices from "./funeralServices";
import RetirementPlanning from "./retirementPlanning";

const GoldenAgersActivity = () => {
  const [activeActivity, setActiveActivity] = useState("educational");
  const handleActivityClick = (activity: any) => {
    setActiveActivity(activity);
  };

  return (
    <Box className={styles.goldenAgersActivityConatiner}>
      <Typography className={styles.headingActivities}>
        <span  className={`${activeActivity === "educational" ? styles.active : ""}`} onClick={() => handleActivityClick("educational")}>
          Educational Activities |
        </span>{" "}
        <span  className={`${activeActivity === "spiritual" ? styles.active : ""}`} onClick={() => handleActivityClick("spiritual")}>
          Spiritual Activities
        </span>{" "}
        |{" "}
        <span  className={`${activeActivity === "healthWellness" ? styles.active : ""}`} onClick={() => handleActivityClick("healthWellness")}>
          Health & Wellness
        </span>{" "}
        |{" "}
        <span  className={`${activeActivity === "inhouse" ? styles.active : ""}`} onClick={() => handleActivityClick("inhouse")}>
          In House Support
        </span>{" "}
        |{" "}
        <span  className={`${activeActivity === "funeral" ? styles.active : ""}`} onClick={() => handleActivityClick("funeral")}>
          Funeral Services
        </span>{" "}
        |{" "}
        <span  className={`${activeActivity === "retirement" ? styles.active : ""}`} onClick={() => handleActivityClick("retirement")}>
          Retirement Planning
        </span>{" "}
      </Typography>
      {activeActivity === "educational" && <EducationalActivities />}
      {activeActivity === "spiritual" && <SpritualActivities />}
      {activeActivity === "healthWellness" && <HealthAndWellness />}
      {activeActivity === "inhouse" && <InHouseSupport />}
      {activeActivity === "funeral" && <FuneralServices />}
      {activeActivity === "retirement" && <RetirementPlanning />}
    </Box>
  );
};

export default GoldenAgersActivity;
